import { __extends } from "tslib";
import { debounce } from 'lodash-es';
import React, { Component } from 'react';
import styles from './TouchIndicator.module.css';
var TouchIndicator = /** @class */ (function (_super) {
    __extends(TouchIndicator, _super);
    function TouchIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            left: 0,
            top: 0,
            isVisible: false,
        };
        _this.hideTouchIndicator = function (callback) {
            _this.setState({
                isVisible: false,
            }, callback);
        };
        _this.showTouchIndicator = function (left, top, callback) {
            _this.setState({
                isVisible: true,
                left: left,
                top: top,
            }, callback);
        };
        _this.flashTouchIndicator = function (_a) {
            var clientX = _a.clientX, clientY = _a.clientY;
            if (_this.state.isVisible) {
                _this.hideTouchIndicator(function () {
                    return setTimeout(_this.showTouchIndicator, 100, clientX, clientY, _this.debouncedHideTouchIndicator);
                });
            }
            else {
                _this.showTouchIndicator(clientX, clientY, _this.debouncedHideTouchIndicator);
            }
        };
        _this.debouncedHideTouchIndicator = debounce(_this.hideTouchIndicator, 600);
        return _this;
    }
    TouchIndicator.prototype.componentDidMount = function () {
        document.addEventListener('click', this.flashTouchIndicator, true);
    };
    TouchIndicator.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.flashTouchIndicator, true);
    };
    TouchIndicator.prototype.render = function () {
        var _a = this.state, left = _a.left, top = _a.top, isVisible = _a.isVisible;
        if (!isVisible)
            return null;
        return (React.createElement("div", { className: styles.touch, style: {
                top: top - 15,
                left: left - 15,
            } }));
    };
    return TouchIndicator;
}(Component));
export default TouchIndicator;
